<template>
  <div>
    <div class="flex-column">
      <div class="d-flex text-h4">{{ config.title }}</div>
      <div class="d-flex text-h6">{{ config.subtitle }}</div>
    </div>

    <div v-if="!fahrdienstStats" class="text-h1 d-flex flex-grow-1 justify-center align-center px-8" style="font-size: 150px">
      {{ count }}
    </div>
    <div v-if="fahrdienstStats" class="fahrdienst-stats">
      <div class="d-flex flex-column pa-3 full-width" style="border-radius: 10px">
        <div class="text-h6" v-html="fahrdienstStats.htmlFahrstundenAtCalculatedDate"></div>
        <div class="text-h6" v-html="fahrdienstStats.htmlDeltaMonthToDate"></div>
      </div>
    </div>
    <div class="full-width d-flex justify-end">
      <v-btn class="ml-auto" dark text @click.stop="$router.push(config.link)">öffnen</v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import configMixin from '@/mixins/configMixin';
import index from '@/modules/customerVbzWorksheet/index';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';

export default {
  name: 'Zueri9OpenServices',
  mixins: [configMixin],
  props: {
    config: Object,
  },
  computed: {
    ...mapState('vbzWorksheet', ['absences', 'zueri9Clients', 'zueri9Reasons', 'absencesByDate', 'zueri9MonthlyExpectedHours']),
    ...mapState('profile', ['user']),

    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    contextDate() {
      return new Date();
    },
    zueri9FahrstundenTagesRichtwert() {
      let fahrstundenTagesRichtwert = this.moduleConfig.zueri9FahrstundenTagesRichtwert;
      let currentMonth = this.contextDate.getMonth() + 1;
      let currentYear = this.contextDate.getFullYear();
      let configuredFahrstundenTagesRichtwert = this.zueri9MonthlyExpectedHours.find((item) => item.year === currentYear && item.month === currentMonth);
      const dailyExpectations = configuredFahrstundenTagesRichtwert ? configuredFahrstundenTagesRichtwert.hours : fahrstundenTagesRichtwert;

      console.debug(`Found configuredFahrstundenTagesRichtwert for ${currentYear}-${currentMonth}`, configuredFahrstundenTagesRichtwert);
      if (!configuredFahrstundenTagesRichtwert)
        console.debug(
          `If no configuredFahrstundenTagesRichtwert found, the default value from moduleConfig.zueri9FahrstundenTagesRichtwert is taken:${fahrstundenTagesRichtwert}`
        );
      return dailyExpectations;
    },
    fahrdienstStats() {
      return worksheetService.calculateZueri9FahrdienstStats({
        absences: this.absences,
        currentWorksheetDate: new Date(),
        zueri9Clients: this.zueri9Clients,
        zueri9Reasons: this.zueri9Reasons,
        zueri9FahrstundenTagesRichtwert: this.zueri9FahrstundenTagesRichtwert,
      });
    },
    count() {
      let filter = this.config.filter;
      let key = worksheetService.buildDateIdFromDate(new Date());
      let absences = this.absencesByDate[key];

      return absences ? absences.filter((a) => !a.deleted).length : 0;
    },
  },
};
</script>

<style scoped>
.theme--dark .fahrdienst-stats {
  background: #a4d5ea;
  color: #f0f0f0 !important;
  border-radius: 4px;
}

.theme--light .fahrdienst-stats {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
}
</style>
